module.exports = __webpack_public_path__ + "img/penta5_bg.08a73714.png";